import axios from 'axios';
import base from '@/api/base.api';
const namespace = 'shipping/orders';

export default {
    trackingInfo: (idCardRequestInfo) => {
        return axios.post(`${base.baseUrl}/${namespace}/tracks-by-cardRequest/${idCardRequestInfo}`).then(({data: {object}}) => object);
    }
}
